import { wrapTranslationsSchema } from '../../helpers/i18n/wrapTranslationsSchema';

export const BundleTranslations = wrapTranslationsSchema({
	name: 'BundleTranslations',
	title: 'Bundle Translations',
	sanityId: 'bundle',
	fields: {
		bundleItems: 'Bundle items',
		selectAllBundleItems: 'Select all',
		clearSelection: 'Clear selection',
		editForm: 'Edit form',
		notPurchasableItemWarning: 'Not purchasable',
	},
});
